import { render, staticRenderFns } from "./eventRecordModal.vue?vue&type=template&id=d4bbfb3e&scoped=true"
import script from "./eventRecordModal.vue?vue&type=script&lang=js"
export * from "./eventRecordModal.vue?vue&type=script&lang=js"
import style0 from "./eventRecordModal.vue?vue&type=style&index=0&id=d4bbfb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bbfb3e",
  null
  
)

export default component.exports